export const CODE_FONT_SIZES = [12, 13, 14, 16, 18, 20] as const;

export type CodeFontSize = (typeof CODE_FONT_SIZES)[number];

export const DEFAULT_CODE_FONT_SIZE: CodeFontSize = 13;

// Static class strings so Tailwind JIT can detect them (runtime-built classes get purged).
const CODE_FONT_SIZE_CLASS: Record<CodeFontSize, string> = {
  12: "text-[0.75rem]",
  13: "text-[0.813rem]",
  14: "text-[0.875rem]",
  16: "text-[1rem]",
  18: "text-[1.125rem]",
  20: "text-[1.25rem]",
};

export function getCodeFontSizeClass(size: CodeFontSize): string {
  return CODE_FONT_SIZE_CLASS[size];
}

export function getCodeFontSizePx(size: CodeFontSize): string {
  return `${size}px`;
}
